import { ui } from '../config/i18n.js';

/**
 * The city, legible.
 *
 * Hidden by default — press `i`, click the lens glyph, or load with
 * `?inspect`. It reports the frame budget, what the renderer is doing, where
 * the traveller is, and whatever each layer chooses to say about itself via
 * `Layer.stats()`. It is the only place in the project allowed to look like
 * a dashboard, and it is never on screen unless asked for.
 */
export class Inspector {
  constructor(ctx) {
    this.ctx = ctx;
    this.on = !!ctx.settings.debug.inspector;
    this.frames = 0;
    this.accum = 0;
    this.fps = 0;
    this.worst = 0;
    this._text = '';

    ctx.bus.on('ui:inspect-toggle', () => this.toggle());
    globalThis.addEventListener('keydown', (e) => {
      if (e.key === 'i' || e.key === 'I') this.toggle();
    });
  }

  toggle() {
    this.on = !this.on;
  }

  /** @param {number} dt @param {import('./App.js').FrameState} state */
  update(dt, state) {
    this.frames++;
    this.accum += dt;
    this.worst = Math.max(this.worst, dt);
    if (this.accum >= 0.5) {
      this.fps = this.frames / this.accum;
      this.frames = 0;
      this.accum = 0;
    }
    if (!this.on) return null;

    const { stage, settings, gaze } = this.ctx;
    const info = stage.info;
    const rows = [
      `<b>isidora</b>  ${settings.tier}  ${this.fps.toFixed(0)} fps  worst ${(this.worst * 1000).toFixed(1)}ms`,
      `journey   t ${state.t.toFixed(4)}  v ${state.velocity.toFixed(4)}  y ${this.ctx.camera.position.y.toFixed(1)}`,
      `render    ${info.calls} calls  ${(info.triangles / 1000).toFixed(0)}k tris  ${info.programs} programs`,
      `memory    ${info.geometries} geo  ${info.textures} tex`,
      `iris      ${state.iris.toFixed(3)}   fov ${this.ctx.camera.fov.toFixed(1)}`,
      `gaze      ${gaze.current ? `${gaze.current.kind} ${(gaze.progress * 100) | 0}%` : '—'}  (${gaze.remembered.size} kept)`,
      '',
    ];
    for (const layer of this.ctx.layers) {
      const s = layer.stats();
      const body = s
        ? Object.entries(s)
            .map(([k, v]) => `${k} ${v}`)
            .join('  ')
        : '';
      rows.push(`<b>${layer.id.padEnd(13)}</b>${body}`);
    }
    rows.push('', ...ui('keys'));
    this.worst *= 0.92;
    this._text = rows.join('\n');
    return this._text;
  }

  get text() {
    return this._text;
  }
}
